import { render, staticRenderFns } from "./jzsb.vue?vue&type=template&id=23c6ea7b&"
import script from "./jzsb.vue?vue&type=script&lang=js&"
export * from "./jzsb.vue?vue&type=script&lang=js&"
import style0 from "./jzsb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports